/**
 * SDR status values for interested leads
 */
export const SDR_STATUS = {
  NEW: 'NEW',
  ATTEMPTED: 'ATTEMPTED',
  CONTACTED: 'CONTACTED',
  NO_ANSWER: 'NO_ANSWER',
  WRONG_NUMBER: 'WRONG_NUMBER',
  BOOKED: 'BOOKED',
  DISQUALIFIED: 'DISQUALIFIED',
  // Appointment Booked page statuses
  SHOW_CONFIRMED: 'SHOW_CONFIRMED',
  NO_ANSWER_VM_SMS_DONE: 'NO_ANSWER_ VM_SMS_DONE', // Note: Space in value matches frontend
  YET_TO_CALL: 'YET_TO_CALL',
  PHONE_NUMBER_NOT_FOUND: 'PHONE_NUMBER_NOT_FOUND',
  UNQUALIFIED: 'UNQUALIFIED', // Lead marked as unqualified by SDR during call
} as const;

export type SdrStatus = typeof SDR_STATUS[keyof typeof SDR_STATUS];

/**
 * Array of all valid SDR statuses
 * P0.3 Fix: Includes appointment booked statuses (SHOW_CONFIRMED, etc.)
 */
export const VALID_SDR_STATUSES = Object.values(SDR_STATUS);